import React, { memo, useRef } from "react";
import {
    Typography,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    TextField,
    Button,
    Snackbar,
    Alert,
    CircularProgress
} from "@mui/material";
import BusinessSettings from "../../../components/business/business/businessSettings";
import TimezoneSelector from "../../../util/timezoneSelector";

const UserPageGeneral = memo(({
    defaultBusinessId,
    defaultBusinessLoading,
    defaultBusinessError,
    businesses,
    handleSelectDefaultBusinessChange,
    username,
    setUsername,
    setUpdated,         // This is setGeneralUpdated passed from parent
    email,
    selectedTimeZoneId,
    token,
    handleTimezoneSelect,
    handleSubmit,
    updated, 
    notificationRef, 
    desc,
    setDesc
}) => {

    return (
        <Typography variant="body1" align="justify" sx={{ p: 2 }}>
            {defaultBusinessId && (
                <>
                    <BusinessSettings />
                    <FormControl margin="normal" fullWidth>
                        <InputLabel id="time-format-label">Default Business Profile</InputLabel>
                        <Select
                            label="Select a Business"
                            variant="outlined"
                            value={defaultBusinessId || ""}
                          onChange={(e) => {
                              handleSelectDefaultBusinessChange(e);
                              setUpdated(true); // Mark as updated when business selection changes
                          }}
                          disabled={defaultBusinessLoading}
                      >
                          {businesses?.map((bus) => (
                              <MenuItem key={bus?.businessBasic?.id} value={bus?.businessBasic?.id}>
                                  {bus?.businessBasic?.name}
                              </MenuItem>
                          ))}
                      </Select>
                      {defaultBusinessLoading && <CircularProgress size={24} />}
                      {defaultBusinessError && (
                          <Typography color="error" variant="caption">
                              {defaultBusinessError}
                          </Typography>
                      )}
                  </FormControl>
              </>
          )}
          <FormControl margin="normal" fullWidth>
              <TextField
                    label="Username"
                  variant="outlined"
                  value={username}
                  onChange={(e) => {
                      setUsername(e.target.value);
                      setUpdated(true); // Mark as updated when username changes
                  }}
                  inputProps={{ maxLength: 50 }}
                  helperText={`${username.length} / 50`} 
              />
          </FormControl>
          <FormControl margin="normal" fullWidth>
                <TextField label="Email" variant="outlined" value={email} disabled />
            </FormControl>

            <FormControl margin="normal" fullWidth>
                <TextField
                    label="Description"
                    variant="outlined"
                    multiline
                    rows={3}
                    value={desc}
                    onChange={(e) => {
                        setDesc(e.target.value);
                        setUpdated(true); // mark as updated when the field changes
                    }}
                    inputProps={{ maxLength: 250 }}
                    helperText={`${desc?.length} / 250`}
                />

            </FormControl>
          <FormControl margin="normal" fullWidth>
              <TimezoneSelector
                  timezoneId={selectedTimeZoneId ?? token.timeZone?.id}
                  onTimezoneSelect={handleTimezoneSelect}
              />
          </FormControl>
          <Button
              color="primary"
              variant="contained"
              fullWidth
              onClick={handleSubmit}
                disabled={!updated} // Disable if no changes or while updating
          >
                {"Save Changes"}
          </Button>
            <Snackbar 
              ref={notificationRef}
              autoHideDuration={6000}
              onClose={() => { }}
          >
              <Alert severity="success">Profile updated successfully!</Alert>
          </Snackbar>
      </Typography>
  );
});

export default UserPageGeneral;
